export enum TrainrunBranchType {
  Trainrun,
  ArrivalBranchWithSection,
  DepartureBranchWithSection,
  ArrivalBranchOnly,
  DepartureBranchOnly,
  ArrivalBranchFilter,
  DepartureBranchFilter,
  Filter,
}
